import { service } from '@ember/service';
import type Store from '@ember-data/store';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import type { AtlasConfig, AtlasDisplay } from 'garaje/utils/atlas';
import times from 'lodash/times';

interface AtlasEditorPanelGeneralComponentProps {
  display: AtlasDisplay;
  config: AtlasConfig;
}

export default class AtlasEditorPanelGeneralComponent extends Component<AtlasEditorPanelGeneralComponentProps> {
  @service declare store: Store;

  @tracked configFloorId?: string;
  @tracked maxZoomOptions: { name: string; id: number }[] = times(15, (num) => ({
    name: (26 - num).toString(),
    id: 26 - num,
  }));
  @tracked inactivityPeriodOptions: { name: string; id: number }[] = [
    {
      name: '30 seconds',
      id: 30,
    },
    {
      name: '1 minute',
      id: 60,
    },
    {
      name: '2 minutes',
      id: 120,
    },
    {
      name: '3 minutes',
      id: 180,
    },
    {
      name: '5 minutes',
      id: 300,
    },
    {
      name: 'Never',
      id: 0,
    },
  ];

  get floorOptions(): { id: string; name: string }[] {
    const floors = this.store.peekAll('floor').slice();

    return floors.map((floor) => ({ id: floor.id, name: floor.name }));
  }

  get selectedFloorId(): string | undefined {
    return this.configFloorId || this.floorOptions[0]?.id;
  }

  updateFloorId = (): void => {
    this.configFloorId = this.args.config?.floorId;
  };
}
